<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <div class="xu-gua1 show-book">
      <h5>【序卦 上】</h5>
      <p>
        有天地，然後萬物生焉。盈天地之間者唯萬物，故受之以屯。屯者，盈也。屯者，物之始生也。
        物生必蒙，故受之以蒙。蒙者，蒙也，物之稺也。物稺不可不養也，故受之以需。需者，飲食之道也。
        飲食必有訟，故受之以訟。訟必有眾起，故受之以師。師者，眾也。
        眾必有所比，故受之以比。比者，比也。比必有所畜，故受之以小畜。物畜然後有禮，故受之以履。
        履而泰，然後安，故受之以泰。泰者，通也。物不可以終通，故受之以否。
        物不可以終否，故受之以同人。與人同者，物必歸焉，故受之以大有。有大者不可以盈，故受之以謙。
        有大而能謙必豫，故受之以豫。豫必有隨，故受之以隨。以喜隨人者必有事，故受之以蠱。蠱者，事也。
        有事而後可大，故受之以臨。臨者，大也。物大然後可觀，故受之以觀。
        可觀而後有所合，故受之以噬嗑。嗑者，合也。
        物不可以苟合而已，故受之以賁。賁者，飾也。
        至飾然後亨則盡矣，故受之以剝。剝者，剝也。
        物不可以終盡剝，窮上反下，故受之以復。復則不妄矣，故受之以无妄。
        有无妄然後可畜，故受之以大畜。物畜然後可養，故受之以頤。頤者，養也。
        不養則不可動，故受之以大過。物不可以終過，故受之以坎。坎者，陷也。
        陷必有所麗，故受之以離。離者，麗也。
      </p>
    </div>
  </main>
{:else}
  <main>
    <div class="xu-gua1 show-book">
      <h5>【序卦 上】</h5>
      <p>
        有天地，然后万物生焉。盈天地之间者唯万物，故受之以屯。屯者，盈也。屯者，物之始生也。
        物生必蒙，故受之以蒙。蒙者，蒙也，物之稺也。物稺不可不养也，故受之以需。需者，饮食之道也。
        饮食必有讼，故受之以讼。讼必有众起，故受之以师。师者，众也。
        众必有所比，故受之以比。比者，比也。比必有所畜，故受之以小畜。物畜然后有礼，故受之以履。
        履而泰，然后安，故受之以泰。泰者，通也。物不可以终通，故受之以否。
        物不可以终否，故受之以同人。与人同者，物必归焉，故受之以大有。有大者不可以盈，故受之以谦。
        有大而能谦必豫，故受之以豫。豫必有随，故受之以随。以喜随人者必有事，故受之以蛊。蛊者，事也。
        有事而后可大，故受之以临。临者，大也。物大然后可观，故受之以观。
        可观而后有所合，故受之以噬嗑。嗑者，合也。
        物不可以苟合而已，故受之以贲。贲者，饰也。
        至饰然后亨则尽矣，故受之以剥。剥者，剥也。
        物不可以终尽剥，穷上反下，故受之以复。复则不妄矣，故受之以无妄。
        有无妄然后可畜，故受之以大畜。物畜然后可养，故受之以颐。颐者，养也。
        不养则不可动，故受之以大过。物不可以终过，故受之以坎。坎者，陷也。
        陷必有所丽，故受之以离。离者，丽也。
      </p>
    </div>
  </main>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
</style>
